module.exports = __webpack_public_path__ + "static/media/bell_notify.4878aeb0.svg";